export const updateMarketingQueryParamsReducer = {
  updateMarketingQueryParams: (state, action) => {
    const {
      utmSource = '',
      campaignId = '',
      adGroupId = '',
      utmTerm = '',
      device = '',
      sourceName = '',
      medium = '',
    } = action.payload;
    state.marketingQueryParams.utmSource = utmSource;
    state.marketingQueryParams.campaignId = campaignId;
    state.marketingQueryParams.adGroupId = adGroupId;
    state.marketingQueryParams.utmTerm = utmTerm;
    state.marketingQueryParams.device = device;
    state.marketingQueryParams.sourceName = sourceName;
    state.marketingQueryParams.medium = medium;
  },
};
